<template>
  <!-- <h1>{{account.EMailAddress}}</h1> -->
  <div class="row">
    <div class="cell">
     <div class="label">
     {{ getUiString(['my_account', 'contact_overview', 'label_emailaddress']) }}
     </div>
     <div class="value">
     {{account.EMailAddress}}
     </div>
    </div>
  </div>
  </template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ClaimLead',
  props: {
    documentId: {
      type: String,
      default () {
        return ''
      }
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      account: 'account/shadowAccount'
    })
  }
}
</script>
